import { type CargoWeight, SuggestionAttribute, type Volume } from '@zen/graphql/types.generated';

export const extractProposedText = (proposedValue: string, suggestionAttribute: SuggestionAttribute): string => {
  switch (suggestionAttribute) {
    case SuggestionAttribute.CARGO_CONTAINER_NUMBER:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_DESCRIPTION:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_GROSS_WEIGHT:
      const cargoWeightSuggestion: CargoWeight = JSON.parse(proposedValue);

      return `${cargoWeightSuggestion.value} ${cargoWeightSuggestion.unit}`;

    case SuggestionAttribute.CARGO_MARKS_AND_NUMBERS:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_SEAL_NUMBER:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_TARIFF_CODES:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_VOLUME:
      const cargoVolumeSuggestion: Volume = JSON.parse(proposedValue);

      return `${cargoVolumeSuggestion.value} ${cargoVolumeSuggestion.unit}`;

    case SuggestionAttribute.PRODUCT:
      return proposedValue;

    default:
      return proposedValue;
  }
};

export const enumToSentenceCase = (value: string): string => {
  return value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase());
};
